export const Type = {
    GET_LIST_LOGISTIC_REQUIRE : "GET_LIST_LOGISTIC_REQUIRE",
    GET_LIST_LOGISTIC_SUCCESS : "GET_LIST_LOGISTIC_SUCCESS",
};


export const getListLogistic = () => ({
    type: Type.GET_LIST_LOGISTIC_REQUIRE
});